import React, { useState, useEffect } from 'react';
import './mudanca.css';

// Componentes
import Navbar from '../../componentes/nav';
import Footer from '../../componentes/folter';

// Imagens locais
import pixImg from "../../img/parceiros/voce-tambem/pix.png";

// Swiper e módulos
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination, EffectFade } from 'swiper/modules';

// Importação dos estilos do Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

// Importação do QRCode
import { QRCodeSVG } from 'qrcode.react';

/* --- FUNÇÃO CORRIGIDA PARA GERAR PIX (igual à primeira página) --- */
function gerarPixString(chave, nome, cidade, valor) {
  // 1. Limpar a chave PIX (remover pontuação do CNPJ)
  const chaveLimpa = chave.replace(/[^0-9]/g, '');
  
  // 2. Validar e formatar o valor
  const valorNumerico = parseFloat(valor);
  if (isNaN(valorNumerico) || valorNumerico <= 0) {
    throw new Error('Valor inválido');
  }
  
  const valorFormatado = valorNumerico.toFixed(2);
  
  // 3. Tratar nome e cidade (remover acentos, limitar tamanho)
  const nomeTratado = nome
    .substring(0, 25)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
    
  const cidadeTratada = cidade
    .substring(0, 15)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
  
  // 4. Construir o payload PIX seguindo o padrão EMV
  const payloadParts = [];
  
  // Payload Format Indicator
  payloadParts.push('000201');
  
  // Merchant Account Information (Campo 26)
  const guiPix = '0014br.gov.bcb.pix';
  const chaveField = `01${chaveLimpa.length.toString().padStart(2, '0')}${chaveLimpa}`;
  const merchantAccountInfo = `${guiPix}${chaveField}`;
  const merchantAccountInfoLength = merchantAccountInfo.length;
  
  payloadParts.push(`26${merchantAccountInfoLength.toString().padStart(2, '0')}${merchantAccountInfo}`);
  
  // Merchant Category Code
  payloadParts.push('52040000');
  
  // Transaction Currency (BRL = 986)
  payloadParts.push('5303986');
  
  // Transaction Amount
  payloadParts.push(`54${valorFormatado.length.toString().padStart(2, '0')}${valorFormatado}`);
  
  // Country Code
  payloadParts.push('5802BR');
  
  // Merchant Name
  payloadParts.push(`59${nomeTratado.length.toString().padStart(2, '0')}${nomeTratado}`);
  
  // Merchant City
  payloadParts.push(`60${cidadeTratada.length.toString().padStart(2, '0')}${cidadeTratada}`);
  
  // Additional Data Field Template
  payloadParts.push('62070503***');
  
  // CRC16 placeholder
  const payloadSemCRC = payloadParts.join('');
  
  // 5. Calcular CRC16-CCITT
  const calcularCRC16 = (str) => {
    let crc = 0xFFFF;
    let j, i;
    
    for (i = 0; i < str.length; i++) {
      crc ^= str.charCodeAt(i) << 8;
      for (j = 0; j < 8; j++) {
        crc = (crc & 0x8000) ? (crc << 1) ^ 0x1021 : crc << 1;
      }
    }
    
    return (crc & 0xFFFF).toString(16).toUpperCase().padStart(4, '0');
  };
  
  const crc = calcularCRC16(payloadSemCRC + '6304');
  
  // 6. Retornar payload completo
  return payloadSemCRC + '6304' + crc;
}

function Mudanca() {
  
  // Estados para o Gerador de Pix
  const [valor, setValor] = useState('');
  const [payloadPix, setPayloadPix] = useState('');
  const [gerandoPix, setGerandoPix] = useState(false);
  const [erroPix, setErroPix] = useState('');
  
  // Estado para controlar qual slider está visível
  const [activeSlider, setActiveSlider] = useState('camisetas');

  // Imagens das Camisetas
  const camisetasImages = [
    "https://somosconexaosocial.org/site_img/seja_mudanca/camisa01.jfif",
    "https://somosconexaosocial.org/site_img/seja_mudanca/camisa02.jfif",
    "https://somosconexaosocial.org/site_img/seja_mudanca/camisa03.jfif",
    "https://somosconexaosocial.org/site_img/seja_mudanca/camisa04.jfif"
  ];

  // Imagens dos Copos
  const coposImages = [
    "https://somosconexaosocial.org/site_img/seja_mudanca/copo01.PNG",
    "https://somosconexaosocial.org/site_img/seja_mudanca/copo02.PNG",
    "https://somosconexaosocial.org/site_img/seja_mudanca/copo03.PNG",
    "https://somosconexaosocial.org/site_img/seja_mudanca/copo04.PNG"
  ];

  // Imagens do Banner
  const bannerDesktop = "https://somosconexaosocial.org/site_img/seja_mudanca/mudanca-banner.jpg";
  const bannerMobile = "https://somosconexaosocial.org/site_img/seja_mudanca/mudanca-banner-menor.jpg";

  // Quando o valor muda, limpa o QR Code existente
  useEffect(() => {
    if (payloadPix) {
      setPayloadPix('');
    }
  }, [valor]);

  // Função chamada ao clicar no botão "Gerar QR Code"
  const handleGerarPix = (e) => {
    e.preventDefault();
    setErroPix('');
    
    // Validação básica
    const valorNumerico = parseFloat(valor);
    if (!valor || isNaN(valorNumerico) || valorNumerico < 1) {
      setErroPix('Por favor, insira um valor válido (mínimo R$ 1,00)');
      return;
    }
    
    setGerandoPix(true);
    
    try {
      // Gera o código PIX usando CNPJ (igual à primeira página)
      const codigo = gerarPixString(
        '07599362000190',  // Chave PIX (CNPJ sem pontuação)
        'CONEXAO SOCIAL',  // Nome do Beneficiário
        'LAGOA DE ITAENGA', // Cidade
        valorNumerico      // Valor digitado pelo usuário
      );
      
      // Validação do payload gerado
      if (!codigo || codigo.length < 50 || !codigo.startsWith('000201')) {
        throw new Error('Falha ao gerar código PIX');
      }
      
      setPayloadPix(codigo);
      
    } catch (error) {
      console.error('Erro ao gerar PIX:', error);
      setErroPix('Erro ao gerar código PIX. Por favor, tente novamente.');
      setPayloadPix('');
    } finally {
      setGerandoPix(false);
    }
  };

  // Função para preencher valores rápidos para os produtos
  const preencherValorProduto = (produto) => {
    if (produto === 'camiseta') {
      setValor('50.00');
    } else if (produto === 'copo') {
      setValor('55.00');
    } else if (produto === 'kit') {
      setValor('155.00');
    }
    setErroPix('');
  };

  // Função para preencher valores rápidos (apenas preenche o input)
  const preencherValorRapido = (valorTeste) => {
    setValor(valorTeste.toString());
    setErroPix('');
  };

  // Função para copiar o código PIX
  const copiarCodigoPix = () => {
    if (payloadPix) {
      navigator.clipboard.writeText(payloadPix)
        .then(() => {
          alert('Código PIX copiado para a área de transferência!');
        })
        .catch(err => {
          console.error('Erro ao copiar:', err);
        });
    }
  };

  return (
    <div className="page-wrapper">
      <Navbar />

      <main className="mudanca-main">
        
        {/* Banner Hero com imagem responsiva */}
        <section className="mudanca-banner">
          <picture>
            <source media="(max-width: 768px)" srcSet={bannerMobile} />
            <img 
              src={bannerDesktop} 
              alt="Seja a mudança que você quer ver no mundo"
              className="banner-img"
            />
          </picture>
        </section>

        {/* Frase destaque abaixo do banner */}
        <section className="frase-destaque">
          <div className="destaque-container">
            <h1 className="destaque-titulo">
              "Seja a mudança que você quer ver no mundo"
            </h1>
            <p className="destaque-subtitulo">
              A transformação social começa com um simples ato de empatia e ação.
            </p>
            <div className="destaque-decoration">
              <div className="deco-line orange"></div>
              <div className="deco-line blue"></div>
            </div>
          </div>
        </section>

        {/* Seção de Conteúdo Principal */}
        <section className="mudanca-content-container">
          
          <div className="mudanca-text">
            <p className="description">
              Inspirados pela célebre frase de Mahatma Gandhi, convidamos você a fazer parte de um movimento coletivo que visa promover a transformação real, a partir de projetos sociais que geram impacto direto nas comunidades mais carentes.
            </p>
            
            <p className="description">
              Esta campanha tem como objetivo criar uma rede de pessoas que, movidas pelo desejo de melhorar o mundo, se conectam e se unem para apoiar iniciativas que verdadeiramente fazem a diferença. A Conexão Social entre cada um de nós é o que permite que juntos possamos construir um futuro mais justo e solidário.
            </p>
            
            <p className="description">
              Cada doação, cada gesto, é um impulso para um futuro melhor. Ao apoiar esta causa, você não está apenas fazendo o bem, mas também se tornando um exemplo de ação e inspiração para outros. Você será parte de um movimento que investe no impacto social de projetos que promovem mudanças positivas e duradouras.
            </p>
            
            <p className="description">
              Agora é o momento de agir. A transformação começa em quem decide fazer a diferença, e esse poder está em suas mãos. Junte-se a nós, doe, inspire e seja o impulso que vai mudar o futuro de muitas vidas.
            </p>
            
            <h2 className="section-title">Doe, participe, e seja a mudança.</h2>
          </div>

          {/* Seção de Produtos da Campanha */}
          <div className="produtos-section">
            <h2 className="section-title">Itens da Campanha</h2>
            <p className="produtos-descricao">
              Os itens da campanha foram pensados para representar a transformação que buscamos: cada peça é um símbolo do impacto social que podemos gerar juntos. A camiseta e copo térmico não são apenas produtos, mas sim formas de espalhar a mensagem de que a mudança começa com a ação de cada um.
            </p>
            
            {/* Botões para alternar entre sliders */}
            <div className="slider-selector">
              <button 
                className={`slider-btn ${activeSlider === 'camisetas' ? 'active' : ''}`}
                onClick={() => setActiveSlider('camisetas')}
              >
                🎽 Camisetas - R$ 50,00
              </button>
              <button 
                className={`slider-btn ${activeSlider === 'copos' ? 'active' : ''}`}
                onClick={() => setActiveSlider('copos')}
              >
                ☕ Copos Térmicos - R$ 55,00
              </button>
            </div>

            {/* Slider de Camisetas */}
            {activeSlider === 'camisetas' && (
              <div className="slider-container">
                <h3 className="slider-title">Camiseta da Campanha</h3>
                <p className="slider-price">R$ 50,00 a unidade</p>
                <Swiper
                  modules={[Navigation, Autoplay, Pagination]}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={true}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  loop={true}
                  className="produto-swiper"
                >
                  {camisetasImages.map((imgUrl, index) => (
                    <SwiperSlide key={index}>
                      <div className="produto-slide">
                        <img 
                          src={imgUrl} 
                          alt={`Camiseta da campanha - Visual ${index + 1}`}
                          className="produto-img"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}

            {/* Slider de Copos Térmicos */}
            {activeSlider === 'copos' && (
              <div className="slider-container">
                <h3 className="slider-title">Copo Térmico da Campanha</h3>
                <p className="slider-price">R$ 55,00 a unidade</p>
                <Swiper
                  modules={[Navigation, Autoplay, Pagination]}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={true}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  loop={true}
                  className="produto-swiper"
                >
                  {coposImages.map((imgUrl, index) => (
                    <SwiperSlide key={index}>
                      <div className="produto-slide">
                        <img 
                          src={imgUrl} 
                          alt={`Copo térmico da campanha - Visual ${index + 1}`}
                          className="produto-img"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}

            {/* Informação sobre o Kit Completo */}
            <div className="kit-info">
              <h3 className="kit-title">🎁 Kit Completo de Impacto</h3>
              <p className="kit-descricao">
                <strong>Kit Completo (Camiseta + Copo Térmico): R$ 155,00</strong>
              </p>
              <p className="kit-text">
                O Kit Completo é uma oportunidade para quem deseja contribuir de forma significativa. 
                Ao comprá-lo, você está ajudando a financiar iniciativas que promovem um futuro mais justo e sustentável. 
                O valor arrecadado com os kits será totalmente direcionado para os projetos que, como a campanha, 
                acreditam que cada pequena ação pode gerar um grande impacto.
              </p>
              <p className="kit-text">
                Essa é a nossa forma de incentivar a participação ativa: ao comprar o kit, você se torna um agente de mudança, 
                investindo não apenas em um futuro melhor, mas também mostrando que a transformação começa em cada um de nós.
              </p>
            </div>
          </div>

          {/* Seção de Doação PIX - Mantendo igual à primeira página */}
          <div className="doacao-section">
            <h2 className="section-title">Faça sua doação agora</h2>
            
            <div className="donation-methods">
              <h3 className="methods-title">Doação via PIX:</h3>
              
              <div className="cards-grid">
                {/* Card PIX Estático (Informativo) */}
                <div className="card-item card-pix">
                  <div className="card-icon">
                    <img src={pixImg} alt="Logo Pix" />
                  </div>
                  <div className="card-info">
                    <h4>Doação via PIX</h4>
                    <p>Chave CNPJ:</p>
                    <p className="pix-key">07.599.362/0001-90</p>
                    <span className="pix-badge">Rápido e Seguro</span>
                  </div>
                </div>
              </div>
            </div>

            {/* --- SEÇÃO: GERADOR DINÂMICO DE PIX (igual à primeira página) --- */}
            <div className="dynamic-pix-section">
              <h3 className="methods-title">Ou defina um valor específico agora:</h3>
              
              <div className="pix-generator-box">
                {/* Botões de produtos */}
                <div className="produto-buttons">
                  <button 
                    className="produto-btn"
                    onClick={() => preencherValorProduto('camiseta')}
                  >
                    🎽 Camiseta - R$ 50,00
                  </button>
                  <button 
                    className="produto-btn"
                    onClick={() => preencherValorProduto('copo')}
                  >
                    ☕ Copo Térmico - R$ 55,00
                  </button>
                  <button 
                    className="produto-btn kit-btn"
                    onClick={() => preencherValorProduto('kit')}
                  >
                    🎁 Kit Completo - R$ 155,00
                  </button>
                </div>
                
                <form onSubmit={handleGerarPix} className="pix-form">
                  <label htmlFor="valorPix">Qual valor você deseja doar?</label>
                  <div className="input-wrapper">
                    <span className="currency-symbol">R$</span>
                    <input 
                      id="valorPix"
                      type="number" 
                      placeholder="0,00" 
                      step="0.01"
                      min="1"
                      value={valor}
                      onChange={(e) => {
                        setValor(e.target.value);
                        setErroPix('');
                      }}
                      disabled={gerandoPix}
                    />
                    <button 
                      type="submit" 
                      disabled={gerandoPix || !valor}
                      className={gerandoPix ? 'loading' : ''}
                    >
                      {gerandoPix ? 'Gerando...' : 'Gerar QR Code'}
                    </button>
                  </div>
                  
                  {/* Botões de valor rápido - APENAS PREENCHEM O INPUT */}
                  <div className="quick-values">
                    <p>Outros valores sugeridos:</p>
                    <div className="quick-buttons">
                      {[10, 25, 100, 200].map((quickVal) => (
                        <button
                          key={quickVal}
                          type="button"
                          onClick={() => preencherValorRapido(quickVal)}
                          className="quick-btn"
                        >
                          R$ {quickVal},00
                        </button>
                      ))}
                    </div>
                  </div>
                </form>

                {erroPix && (
                  <div className="error-message">
                    <p>⚠️ {erroPix}</p>
                  </div>
                )}

                {/* Renderiza o QR Code somente se houver payload gerado */}
                {payloadPix && (
                  <div className="pix-result fadeIn">
                    <h4>QR Code PIX para R$ {parseFloat(valor).toFixed(2).replace('.', ',')}</h4>
                    
                    <div className="qr-frame">
                      <QRCodeSVG 
                        value={payloadPix} 
                        size={220}
                        level="M"
                        includeMargin={true}
                      />
                    </div>
                    
                    <p className="pix-instruction">
                      1. Abra o app do seu banco<br/>
                      2. Escaneie o código acima<br/>
                      3. Confirme o pagamento
                    </p>
                    
                    <div className="copy-paste-box">
                      <input 
                        type="text" 
                        readOnly 
                        value={payloadPix} 
                        onClick={(e) => e.target.select()}
                      />
                      <button onClick={copiarCodigoPix}>
                        Copiar Código PIX
                      </button>
                    </div>
                    
                    <p className="pix-note">
                      <small>
                        <strong>Importante:</strong> Este QR Code é válido apenas para R$ {parseFloat(valor).toFixed(2).replace('.', ',')}.
                        Para outro valor, digite acima e gere um novo código.
                      </small>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Frase Final Inspiradora */}
          <div className="final-quote-container">
            <h2 className="final-quote">
              "Sua ação hoje é a <span className="underline-orange">semente da transformação</span> de amanhã."
            </h2>
          </div>

        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Mudanca;